document.querySelectorAll('[data-brand-directory]').forEach(directory=>{const section=directory.closest('.brands-page');let vendors=[];try{vendors=JSON.parse(section.querySelector('[data-vendors-json]').textContent)}catch(e){return}vendors.sort((a,b)=>a.localeCompare(b));const groups=new Map();vendors.forEach(name=>{const letter=name.charAt(0).toUpperCase();if(!groups.has(letter)){const group=document.createElement('div');group.className='brand-letter';group.id='brand-'+letter;const heading=document.createElement('h2');heading.textContent=letter;const list=document.createElement('div');list.className='brand-list';group.append(heading,list);directory.append(group);groups.set(letter,list)}const link=document.createElement('a');link.href='/collections/vendors?q='+encodeURIComponent(name);link.dataset.brand=name;link.textContent=name+' ↗';groups.get(letter).append(link)});const input=section.querySelector('[data-brand-search]');input.addEventListener('input',()=>{const term=input.value.trim().toLocaleLowerCase();let found=0;directory.querySelectorAll('.brand-letter').forEach(group=>{let count=0;group.querySelectorAll('[data-brand]').forEach(link=>{const visible=link.dataset.brand.toLocaleLowerCase().includes(term);link.hidden=!visible;if(visible)count++});group.hidden=count===0;found+=count});section.querySelector('[data-brands-empty]').hidden=found>0})});
document.querySelectorAll('.product-tabs').forEach(section=>{const tabs=[...section.querySelectorAll('[role="tab"]')];tabs.forEach(tab=>tab.addEventListener('click',()=>{tabs.forEach(t=>{const active=t===tab;t.setAttribute('aria-selected',String(active));document.getElementById(t.getAttribute('aria-controls')).hidden=!active})}))});
if (!customElements.get('catwa-navigation')) {
  customElements.define('catwa-navigation', class extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.events = new AbortController();
      const signal = this.events.signal;
      this.toggleButton = this.querySelector('[data-nav-toggle]');
      this.navigation = this.querySelector('[data-navigation]');
      if (!this.toggleButton || !this.navigation) return;
      this.backButton = this.querySelector('[data-nav-back]');
      this.titleElement = this.querySelector('[data-nav-title]');
      this.rootTitle = this.titleElement?.dataset.rootTitle || this.titleElement?.textContent || this.navigation.getAttribute('aria-label');
      this.menus = [...this.querySelectorAll('[data-nav-details]')];
      this.childMenus = [...this.querySelectorAll('[data-nav-child]')];
      this.mediaQuery = matchMedia('(max-width: 1050px)');
      this.hoverQuery = matchMedia('(hover: hover) and (pointer: fine)');
      this.navAttributes = new Map(['role', 'aria-modal', 'aria-label', 'tabindex'].map(name => [name, this.navigation.getAttribute(name)]));
      this.inertElements = [];
      this.screenElements = [];
      this.scrollStyles = [];
      this.toggleButton.addEventListener('click', () => this.isMobileOpen ? this.closeAll({restoreFocus:true}) : this.openMobile(), {signal});
      this.addEventListener('click', event => this.handleClick(event), {signal});
      this.addEventListener('keydown', event => this.handleKeydown(event), {signal});
      this.menus.forEach(menu => {
        menu.addEventListener('toggle', () => {
          menu.querySelector(':scope > summary')?.setAttribute('aria-expanded', String(menu.open));
          if (menu.open) this.openMenu(menu);
          else if (this.activeMenu === menu) {
            this.activeMenu = null;
            this.renderScreen();
          }
        }, {signal});
        const item = menu.closest('.catwa-nav__item') || menu;
        item.addEventListener('pointerenter', event => {
          if (!this.useHover || event.pointerType === 'touch') return;
          this.clearHover();
          this.hoveredMenu = menu;
          this.hoverTimer = setTimeout(() => this.openMenu(menu), 100);
        }, {signal});
        item.addEventListener('pointerleave', event => {
          if (!this.useHover || event.pointerType === 'touch') return;
          this.clearHover();
          this.hoveredMenu = null;
          this.hoverTimer = setTimeout(() => {
            if (!this.hoveredMenu && !menu.contains(document.activeElement)) this.closePanels();
          }, 180);
        }, {signal});
      });
      this.childMenus.forEach(child => child.addEventListener('toggle', () => {
        if (!this.isSheet && !child.open) child.open = true;
        child.querySelector(':scope > summary')?.setAttribute('aria-expanded', String(child.open));
      }, {signal}));
      this.querySelectorAll('.header-search, .catwa-account').forEach(disclosure => disclosure.addEventListener('toggle', () => {
        if (disclosure.open) this.closeAll();
      }, {signal}));
      document.addEventListener('click', event => {
        if (!(event.target instanceof Element)) return;
        if (!this.contains(event.target) || event.target.closest('.header-cart')) this.closeAll();
      }, {signal, capture:true});
      this.addEventListener('focusout', event => {
        if (this.isSheetOpen || !event.relatedTarget) return;
        if (!this.contains(event.relatedTarget) || (this.navigation.contains(event.target) && !this.navigation.contains(event.relatedTarget))) this.closeAll();
      }, {signal});
      document.addEventListener('focusin', event => {
        if (!this.isSheetOpen || this.navigation.contains(event.target)) return;
        if (document.querySelector('dialog[open]')) this.closeAll();
        else this.focusFirst();
      }, {signal});
      this.mediaQuery.addEventListener('change', () => {
        const restoreFocus = this.isMobileOpen && this.navigation.contains(document.activeElement);
        this.closeAll();
        this.resetChildren();
        if (restoreFocus) {
          const target = this.mediaQuery.matches ? this.toggleButton : this.navigation.querySelector('summary, a[href]');
          target?.focus({preventScroll:true});
        }
        this.refreshCarousels();
      }, {signal});
      this.hoverQuery.addEventListener('change', () => this.clearHover(), {signal});
      document.addEventListener('shopify:block:select', event => {
        if (!(event.target instanceof Element) || !this.contains(event.target)) return;
        const menu = event.target.closest('[data-nav-details]') || event.target.querySelector('[data-nav-details]');
        if (!menu) return;
        if (this.mediaQuery.matches) this.openMobile({focus:false});
        this.openMenu(menu);
      }, {signal});
      this.querySelectorAll('[data-nav-tabs]').forEach(group => {
        const tabs = [...group.querySelectorAll('[data-nav-tab]')];
        this.selectTab(tabs.find(tab => tab.getAttribute('aria-selected') === 'true') || tabs[0]);
      });
      this.rails = [...this.querySelectorAll('[data-nav-rail]')];
      this.rails.forEach(rail => rail.addEventListener('scroll', () => this.updateCarousel(rail), {signal, passive:true}));
      if (typeof ResizeObserver !== 'undefined') {
        this.resizeObserver = new ResizeObserver(() => this.refreshCarousels());
        this.rails.forEach(rail => this.resizeObserver.observe(rail));
      }
      this.closeAll();
      this.resetChildren();
      this.refreshCarousels();
    }
    get isMobileOpen() { return this.hasAttribute('data-mobile-open'); }
    get isSheet() { return this.mediaQuery?.matches && this.dataset.mobileStyle !== 'classic'; }
    get isSheetOpen() { return this.isSheet && this.isMobileOpen; }
    get useHover() { return !this.mediaQuery.matches && this.hoverQuery.matches && this.dataset.desktopTrigger === 'hover'; }
    clearHover() { clearTimeout(this.hoverTimer); }
    handleClick(event) {
      if (!(event.target instanceof Element)) return;
      const target = event.target;
      if (target.closest('[data-nav-close], [data-nav-backdrop]')) {
        event.preventDefault();
        this.closeAll({restoreFocus:true});
        return;
      }
      if (target.closest('[data-nav-back]')) {
        event.preventDefault();
        this.goBack();
        return;
      }
      if (target.closest('[data-nav-search]')) {
        event.preventDefault();
        this.closeAll();
        const search = this.querySelector('.header-search');
        if (search) {
          search.open = true;
          (search.querySelector('input:not([type="hidden"])') || search.querySelector('summary'))?.focus({preventScroll:true});
        }
        return;
      }
      const tab = target.closest('[data-nav-tab]');
      if (tab) {
        event.preventDefault();
        this.selectTab(tab);
        return;
      }
      const control = target.closest('[data-nav-prev], [data-nav-next]');
      if (control) {
        event.preventDefault();
        const rail = control.closest('[data-nav-carousel]')?.querySelector('[data-nav-rail]');
        if (rail) {
          const rtl = getComputedStyle(rail).direction === 'rtl';
          const direction = (control.hasAttribute('data-nav-next') ? 1 : -1) * (rtl ? -1 : 1);
          rail.scrollBy({left:direction * rail.clientWidth * .85, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
        }
        return;
      }
      const summary = target.closest('summary');
      if (summary?.parentElement?.matches('[data-nav-details]')) {
        event.preventDefault();
        this.clearHover();
        const menu = summary.parentElement;
        if (menu.open) this.isSheet ? this.goBack() : this.closePanels();
        else this.openMenu(menu, {focus:this.isSheetOpen});
        return;
      }
      if (summary?.parentElement?.matches('[data-nav-child]') && !this.isSheet) {
        event.preventDefault();
        summary.parentElement.open = true;
        return;
      }
      if (summary?.parentElement?.matches('.header-search, .catwa-account')) this.closeAll();
      if (this.navigation.contains(target) && target.closest('a[href]')) this.closeAll();
    }
    handleKeydown(event) {
      const tab = event.target.closest?.('[data-nav-tab]');
      if (tab && ['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) {
        const tabs = [...tab.closest('[data-nav-tabs]').querySelectorAll('[data-nav-tab]')];
        const rtl = getComputedStyle(tab).direction === 'rtl';
        const direction = (event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1);
        const next = event.key === 'Home' ? tabs[0] : event.key === 'End' ? tabs.at(-1) : tabs[(tabs.indexOf(tab) + direction + tabs.length) % tabs.length];
        event.preventDefault();
        this.selectTab(next, true);
        return;
      }
      if (event.key === 'Escape' && (this.isMobileOpen || this.activeMenu)) {
        event.preventDefault();
        event.stopPropagation();
        const child = this.isSheetOpen ? document.activeElement?.closest('[data-nav-child][open]') : null;
        if (child && this.navigation.contains(child)) {
          child.open = false;
          child.querySelector(':scope > summary')?.focus({preventScroll:true});
        } else if (this.activeMenu) this.goBack();
        else this.closeAll({restoreFocus:true});
        return;
      }
      if (event.key !== 'Tab' || !this.isSheetOpen) return;
      const items = this.focusableItems();
      const first = items[0], last = items.at(-1), active = document.activeElement;
      if (!items.length) {
        event.preventDefault();
        this.navigation.focus({preventScroll:true});
      } else if (event.shiftKey && (active === first || active === this.navigation || !this.navigation.contains(active))) {
        event.preventDefault();
        last.focus({preventScroll:true});
      } else if (!event.shiftKey && (active === last || !this.navigation.contains(active))) {
        event.preventDefault();
        first.focus({preventScroll:true});
      }
    }
    openMobile({focus = true} = {}) {
      if (!this.mediaQuery.matches) return;
      if (this.isMobileOpen) return;
      this.clearHover();
      this.closePanels();
      this.querySelectorAll('.header-search[open], .catwa-account[open]').forEach(disclosure => { disclosure.open = false; });
      this.resetChildren();
      this.setAttribute('data-mobile-open', '');
      this.classList.add('is-mobile-open');
      this.toggleButton.setAttribute('aria-expanded', 'true');
      this.navigation.scrollTop = 0;
      if (this.isSheet) {
        this.navigation.setAttribute('role', 'dialog');
        this.navigation.setAttribute('aria-modal', 'true');
        this.navigation.setAttribute('tabindex', '-1');
        this.lockScroll();
        this.setBackgroundInert();
      }
      this.renderScreen();
      if (focus) this.focusFirst();
      this.refreshCarousels();
    }
    openMenu(menu, {focus = false} = {}) {
      if (!this.menus.includes(menu)) return;
      this.menus.forEach(other => {
        other.open = other === menu;
        other.querySelector(':scope > summary')?.setAttribute('aria-expanded', String(other === menu));
      });
      if (focus && this.isSheetOpen && !this.activeMenu) this.rootScrollTop = this.navigation.scrollTop;
      this.activeMenu = menu;
      this.renderScreen();
      if (focus && this.isSheetOpen) {
        this.navigation.scrollTop = 0;
        const body = menu.querySelector('[data-nav-screen]');
        if (body) body.scrollTop = 0;
        (this.backButton || this.navigation).focus({preventScroll:true});
      }
      this.refreshCarousels();
    }
    goBack() {
      const summary = this.activeMenu?.querySelector(':scope > summary');
      this.closePanels();
      if (this.isSheetOpen) this.navigation.scrollTop = this.rootScrollTop || 0;
      summary?.focus({preventScroll:true});
    }
    closePanels() {
      this.clearHover();
      this.menus?.forEach(menu => {
        menu.open = false;
        menu.querySelector(':scope > summary')?.setAttribute('aria-expanded', 'false');
      });
      this.activeMenu = null;
      this.renderScreen();
    }
    renderScreen() {
      this.screenElements?.forEach(element => { element.inert = false; });
      this.screenElements = [];
      const menu = this.isSheetOpen ? this.activeMenu : null;
      this.classList.toggle('has-nav-screen', Boolean(menu));
      if (this.backButton) this.backButton.hidden = !menu;
      if (this.titleElement) this.titleElement.textContent = menu ? menu.dataset.title || menu.querySelector(':scope > summary')?.textContent.trim() : this.rootTitle;
      if (!menu) return;
      const activeItem = menu.closest('.catwa-nav__item') || menu.parentElement;
      const root = this.querySelector('[data-nav-root]');
      const candidates = [...(root?.children || []), this.querySelector('[data-nav-footer]'), menu.querySelector(':scope > summary')];
      candidates.forEach(element => {
        if (!element || element === activeItem || element.inert) return;
        element.inert = true;
        this.screenElements.push(element);
      });
    }
    resetChildren() {
      this.childMenus?.forEach(child => {
        child.open = !this.isSheet;
        child.querySelector(':scope > summary')?.setAttribute('aria-expanded', String(child.open));
      });
    }
    focusableItems() {
      return [...this.navigation.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), summary, [tabindex]')]
        .filter(element => element.tabIndex >= 0 && !element.closest('[hidden], [inert]') && element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden');
    }
    focusFirst() {
      (this.focusableItems()[0] || this.navigation).focus({preventScroll:true});
    }
    lockScroll() {
      if (this.scrollStyles.length) return;
      [[document.documentElement, 'overflow'], [document.body, 'overflow'], [document.body, 'overscroll-behavior']].forEach(([element, property]) => {
        this.scrollStyles.push({element, property, value:element.style.getPropertyValue(property), priority:element.style.getPropertyPriority(property)});
        element.style.setProperty(property, property === 'overscroll-behavior' ? 'none' : 'hidden');
      });
    }
    unlockScroll() {
      this.scrollStyles?.forEach(({element, property, value, priority}) => {
        if (value) element.style.setProperty(property, value, priority);
        else element.style.removeProperty(property);
      });
      this.scrollStyles = [];
    }
    setBackgroundInert() {
      let branch = this.navigation;
      while (branch && branch !== document.body) {
        const parent = branch.parentElement;
        if (!parent) break;
        [...parent.children].forEach(element => {
          if (element === branch || !(element instanceof HTMLElement) || element.inert || element.matches('script, style, link, [data-nav-backdrop]')) return;
          element.inert = true;
          this.inertElements.push(element);
        });
        branch = parent;
      }
    }
    restoreBackground() {
      this.inertElements?.forEach(element => { element.inert = false; });
      this.inertElements = [];
    }
    selectTab(tab, focus = false) {
      if (!tab) return;
      const group = tab.closest('[data-nav-tabs]');
      if (!group) return;
      group.querySelectorAll('[data-nav-tab]').forEach(button => {
        const selected = button === tab;
        button.setAttribute('aria-selected', String(selected));
        button.tabIndex = selected ? 0 : -1;
        const id = button.getAttribute('aria-controls');
        const panel = id ? this.querySelector(`#${CSS.escape(id)}`) : null;
        if (panel?.matches('[data-nav-tab-panel]')) panel.hidden = !selected;
      });
      if (focus) {
        tab.focus({preventScroll:true});
        const list = tab.closest('[role="tablist"]');
        if (list) {
          const bounds = list.getBoundingClientRect(), target = tab.getBoundingClientRect();
          if (target.left < bounds.left + 24) list.scrollBy({left: target.left - bounds.left - 24, behavior:'auto'});
          else if (target.right > bounds.right - 24) list.scrollBy({left: target.right - bounds.right + 24, behavior:'auto'});
        }
      }
      this.refreshCarousels();
    }
    updateCarousel(rail) {
      const carousel = rail.closest('[data-nav-carousel]');
      if (!carousel) return;
      const distance = Math.abs(rail.scrollLeft), maximum = Math.max(0, rail.scrollWidth - rail.clientWidth);
      const previous = carousel.querySelector('[data-nav-prev]'), next = carousel.querySelector('[data-nav-next]');
      if (previous) previous.disabled = distance <= 1;
      if (next) next.disabled = distance >= maximum - 1;
    }
    refreshCarousels() {
      cancelAnimationFrame(this.carouselFrame);
      this.carouselFrame = requestAnimationFrame(() => this.rails?.forEach(rail => this.updateCarousel(rail)));
    }
    closeAll({restoreFocus = false} = {}) {
      const wasOpen = this.isMobileOpen;
      this.closePanels();
      this.removeAttribute('data-mobile-open');
      this.classList.remove('is-mobile-open', 'has-nav-screen');
      this.toggleButton?.setAttribute('aria-expanded', 'false');
      this.navAttributes?.forEach((value, name) => {
        if (value === null) this.navigation.removeAttribute(name);
        else this.navigation.setAttribute(name, value);
      });
      this.restoreBackground();
      this.unlockScroll();
      if (restoreFocus && wasOpen && this.toggleButton?.isConnected) this.toggleButton.focus({preventScroll:true});
    }
    disconnectedCallback() {
      this.events?.abort();
      this.closeAll();
      this.clearHover();
      cancelAnimationFrame(this.carouselFrame);
      this.resizeObserver?.disconnect();
    }
  });
}
if (!customElements.get('catwa-product')) {
  customElements.define('catwa-product', class extends HTMLElement {
    connectedCallback() {
      this.events = new AbortController();
      this.requestNumber = 0;
      const signal = this.events.signal;
      this.addEventListener('change', event => {
        if (event.target.matches('[data-option-select], [data-option-radio], [data-selling-plan]')) this.updateSelection(event.target.id);
      }, {signal});
      this.addEventListener('click', event => {
        if (event.target.closest('[data-variant-retry]')) this.updateSelection();
        const thumbnail = event.target.closest('[data-media-target]');
        if (thumbnail) this.selectMedia(thumbnail.dataset.mediaTarget);
        const step = event.target.closest('[data-quantity-step]');
        if (step) {
          const input = this.querySelector('[name="quantity"]');
          const minimum = Number(input.min) || 1, increment = Number(input.step) || 1;
          let value = Math.max(minimum, (Number(input.value) || minimum) + Number(step.dataset.quantityStep) * increment);
          if (input.max) value = Math.min(value, Number(input.max));
          input.value = value;
          input.dispatchEvent(new Event('change', {bubbles:true}));
        }
        const tab = event.target.closest('[data-info-tab]');
        if (tab) this.selectTab(tab);
      }, {signal});
      this.addEventListener('keydown', event => {
        if (!event.target.matches('[data-info-tab]') || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        const tabs = [...this.querySelectorAll('[data-info-tab]')], index = tabs.indexOf(event.target);
        const rtl = document.documentElement.dir === 'rtl';
        const delta = (event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1);
        const next = event.key === 'Home' ? tabs[0] : event.key === 'End' ? tabs.at(-1) : tabs[(index + delta + tabs.length) % tabs.length];
        event.preventDefault(); this.selectTab(next); next.focus();
      }, {signal});
      this.addEventListener('submit', event => {
        if (!event.target.matches('.catwa-product-form')) return;
        const id = this.querySelector('[data-variant-id]'), button = this.querySelector('[data-add-to-cart]');
        if (this.getAttribute('aria-busy') === 'true' || id.disabled || !id.value || button.disabled) event.preventDefault();
      }, {signal});
      this.addEventListener('shopify:block:select', event => {
        const panel = event.target.closest('[data-info-panel]');
        if (panel) {
          const tab = this.querySelector(`[aria-controls="${CSS.escape(panel.id)}"]`);
          if (tab) this.selectTab(tab);
          panel.open = true;
        }
      }, {signal});
      this.setupTabs();
      const sticky = this.querySelector('[data-sticky-purchase]'), button = this.querySelector('[data-add-to-cart]');
      if (sticky && button && 'IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          const entry = entries[0]; sticky.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
          document.body.classList.toggle('has-sticky-purchase', !sticky.hidden);
        }, {threshold:0});
        this.observer.observe(button);
      }
      this.syncSticky();
    }
    setupTabs() {
      const information = this.querySelector('[data-information-style]');
      if (!information) return;
      const useTabs = information.dataset.informationStyle === 'tabs';
      information.classList.toggle('is-tabs-ready', useTabs);
      if (useTabs) this.selectTab(information.querySelector('[data-info-tab]'));
    }
    selectTab(tab) {
      if (!tab) return;
      const information = tab.closest('[data-information-style]');
      if (information.dataset.informationStyle !== 'tabs') return;
      information.querySelectorAll('[data-info-tab]').forEach(button => {
        const active = tab === button; button.setAttribute('aria-selected', String(active)); button.tabIndex = active ? 0 : -1;
        const panel = this.querySelector(`[id="${CSS.escape(button.getAttribute('aria-controls'))}"]`);
        panel.hidden = !active; panel.open = true; panel.setAttribute('role','tabpanel'); panel.setAttribute('aria-labelledby',button.id); panel.tabIndex = 0;
      });
    }
    selectMedia(id) {
      this.querySelectorAll('[data-media-id]').forEach(panel => {
        panel.hidden = panel.dataset.mediaId !== id;
        if (panel.hidden) panel.querySelectorAll('video').forEach(video => video.pause());
      });
      this.querySelectorAll('[data-media-target]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.mediaTarget === id)));
    }
    syncSticky() {
      const stickyButton = this.querySelector('[data-sticky-submit]'), button = this.querySelector('[data-add-to-cart]');
      if (stickyButton && button) {stickyButton.disabled = button.disabled; stickyButton.textContent = button.textContent;}
      const stickyPrice = this.querySelector('[data-sticky-price]');
      if (stickyPrice) stickyPrice.innerHTML = this.querySelector('[data-product-price]').innerHTML;
    }
    async updateSelection(focusId) {
      const sequence = ++this.requestNumber;
      this.request?.abort(); this.request = new AbortController();
      const selected = [...this.querySelectorAll('[data-option-select]')].map(select => select.selectedOptions[0]);
      selected.push(...this.querySelectorAll('[data-option-radio]:checked'));
      const idInput = this.querySelector('[data-variant-id]'), button = this.querySelector('[data-add-to-cart]');
      const status = this.querySelector('[data-variant-status]'), retry = this.querySelector('[data-variant-retry]');
      const buyNow = this.querySelector('[data-buy-now]'), selectedPlan = this.querySelector('[data-selling-plan]')?.value;
      const originalQuantity = this.querySelector('[name="quantity"]').value;
      this.setAttribute('aria-busy','true'); button.disabled = true; idInput.disabled = true; this.syncSticky();
      if (buyNow) {buyNow.hidden = true; buyNow.inert = true;}
      status.textContent = this.dataset.updating; retry.hidden = true;
      const controller = this.request;
      const timeout = setTimeout(() => controller.abort(), 15000);
      try {
        const changed = focusId ? this.querySelector(`[id="${CSS.escape(focusId)}"]`) : null;
        const sibling = changed?.selectedOptions?.[0]?.dataset.productUrl || changed?.dataset.productUrl;
        if (sibling && new URL(sibling,location.origin).pathname !== new URL(this.dataset.productUrl,location.origin).pathname) {
          const target = new URL(sibling,location.origin), preview = new URL(location.href).searchParams.get('preview_theme_id');
          if (preview) target.searchParams.set('preview_theme_id',preview);
          if (target.origin === location.origin) location.assign(target.href);
          return;
        }
        const ids = selected.map(option => option?.dataset.optionValueId);
        if (ids.some(id => !id)) throw Error('Missing option values');
        const url = new URL(this.dataset.productUrl,location.origin);
        const preview = new URL(location.href).searchParams.get('preview_theme_id');
        if (preview) url.searchParams.set('preview_theme_id',preview);
        url.searchParams.delete('variant'); url.searchParams.set('section_id',this.dataset.sectionId);
        if (ids.length) url.searchParams.set('option_values',ids.join(','));
        else if (idInput.value) url.searchParams.set('variant',idInput.value);
        if (selectedPlan) url.searchParams.set('selling_plan',selectedPlan);
        const response = await fetch(url,{signal:this.request.signal,credentials:'same-origin'});
        if (!response.ok) throw Error('Selection request failed');
        const html = new DOMParser().parseFromString(await response.text(),'text/html');
        if (sequence !== this.requestNumber || !this.isConnected) return;
        const incoming = html.getElementById(this.id);
        const fields = ['[data-product-options]','[data-product-price]','[data-product-availability]','[data-variant-id]','[data-add-to-cart]','[name="quantity"]'];
        if (!incoming || fields.some(selector => !incoming.querySelector(selector))) throw Error('Incomplete product');
        const activeId = this.contains(document.activeElement) ? document.activeElement.id : null;
        ['[data-product-options]','[data-product-price]','[data-product-availability]','[data-product-plans]','[data-product-specs]','[data-product-sku]','[data-product-volume]','[data-product-fulfillment]','[data-product-stock-request]','[data-product-gallery]'].forEach(selector => {
          const target = this.querySelector(selector), source = incoming.querySelector(selector);
          if (target && source) target.innerHTML = source.innerHTML;
        });
        const freshId = incoming.querySelector('[data-variant-id]'), freshButton = incoming.querySelector('[data-add-to-cart]');
        idInput.value = freshId.value; idInput.disabled = freshId.disabled || !freshId.value;
        button.textContent = freshButton.textContent; button.disabled = freshButton.disabled || idInput.disabled;
        const freshBuy = incoming.querySelector('[data-buy-now]');
        if (buyNow && freshBuy) {
          buyNow.innerHTML = freshBuy.innerHTML; buyNow.hidden = button.disabled; buyNow.inert = button.disabled;
          // An optional accelerated-checkout failure must not invalidate a resolved variant.
          try {if (!this.paymentButtonFailed) window.Shopify?.PaymentButton?.init?.();}
          catch (_) {this.paymentButtonFailed = true;}
          if (this.paymentButtonFailed) {buyNow.hidden = true; buyNow.inert = true;}
        }
        const quantity = this.querySelector('[name="quantity"]'), freshQuantity = incoming.querySelector('[name="quantity"]');
        ['min','max','step'].forEach(attribute => {if (freshQuantity.hasAttribute(attribute)) quantity.setAttribute(attribute,freshQuantity.getAttribute(attribute)); else quantity.removeAttribute(attribute);});
        const minimum = Number(quantity.min) || 1, increment = Number(quantity.step) || 1;
        let count = Math.max(minimum,Number(originalQuantity) || minimum); count = minimum + Math.floor((count - minimum) / increment) * increment;
        if (quantity.max) count = Math.min(count,Number(quantity.max)); quantity.value = count;
        if (this.dataset.history !== 'false') {
          const pageUrl = new URL(location.href); ['section_id','variant','option_values','selling_plan'].forEach(key => pageUrl.searchParams.delete(key));
          if (freshId.value) pageUrl.searchParams.set('variant',freshId.value); else if (ids.length) pageUrl.searchParams.set('option_values',ids.join(','));
          const plan = this.querySelector('[data-selling-plan]')?.value; if (plan) pageUrl.searchParams.set('selling_plan',plan);
          history.replaceState(history.state,'',pageUrl.href);
        }
        status.textContent = incoming.querySelector('[data-product-availability]').textContent.trim();
        this.syncSticky();
        if (activeId) this.querySelector(`[id="${CSS.escape(activeId)}"]`)?.focus({preventScroll:true});
        this.dispatchEvent(new CustomEvent('catwa:variant-change',{bubbles:true,detail:{variantId:freshId.value || null,available:!button.disabled}}));
        document.dispatchEvent(new CustomEvent('catwa:content-updated'));
      } catch (error) {
        if (sequence !== this.requestNumber || !this.isConnected) return;
        status.textContent = this.dataset.error; retry.hidden = false; button.disabled = true; idInput.disabled = true; this.syncSticky();
        if (buyNow) {buyNow.hidden = true; buyNow.inert = true;}
      } finally {
        clearTimeout(timeout); if (sequence === this.requestNumber) this.removeAttribute('aria-busy');
      }
    }
    disconnectedCallback() {this.events?.abort(); this.request?.abort(); this.observer?.disconnect(); if (this.querySelector('[data-sticky-purchase]')) document.body.classList.remove('has-sticky-purchase');}
  });
}

if (!customElements.get('catwa-cart-terms')) {
  customElements.define('catwa-cart-terms', class extends HTMLElement {
    static accepted = false;
    static setAccepted(value) {
      this.accepted = value;
      document.querySelectorAll('catwa-cart-terms').forEach(terms => terms.sync());
    }
    connectedCallback() {
      this.events?.abort();
      this.events = new AbortController();
      this.form = this.closest('[data-cart-form]');
      this.checkbox = this.querySelector('[data-cart-terms-checkbox]');
      this.hint = this.querySelector('[data-cart-terms-hint]');
      this.error = this.querySelector('[data-cart-terms-error]');
      if (!this.form || !this.checkbox) return;
      const signal = this.events.signal;
      this.checkbox.addEventListener('change', () => this.constructor.setAccepted(this.checkbox.checked), {signal});
      this.checkbox.addEventListener('invalid', () => this.showError(), {signal});
      this.form.addEventListener('submit', event => {
        if (event.submitter?.name !== 'checkout' || this.checkbox.checked) return;
        event.preventDefault();
        this.showError();
        this.checkbox.focus();
      }, {signal, capture: true});
      this.sync();
    }
    sync() {
      if (!this.checkbox || !this.form) return;
      const accepted = this.constructor.accepted;
      this.checkbox.checked = accepted;
      const checkout = this.form.querySelector('button[name="checkout"]');
      if (checkout) {
        checkout.disabled = !accepted || this.form.hasAttribute('aria-busy');
        checkout.setAttribute('aria-disabled', String(checkout.disabled));
        if (this.hint) checkout.setAttribute('aria-describedby', this.hint.id);
      }
      if (this.hint) this.hint.hidden = accepted;
      if (accepted) {
        this.checkbox.removeAttribute('aria-invalid');
        if (this.error) this.error.hidden = true;
      }
    }
    showError() {
      this.checkbox.setAttribute('aria-invalid', 'true');
      if (this.error) this.error.hidden = false;
    }
    disconnectedCallback() { this.events?.abort(); }
  });
}

(() => {
  const config = document.getElementById('CatwaExperience');
  if (!config) return;
  const root = config.dataset.root || window.Shopify?.routes?.root || '/';
  const drawer = document.getElementById('CatwaCartDrawer');
  const quick = document.getElementById('CatwaQuickView');
  const media = document.getElementById('CatwaMediaDialog');
  const reducedMotion = () => document.body.dataset.motion === 'false' || matchMedia('(prefers-reduced-motion: reduce)').matches;
  const safeURL = value => {
    const url = new URL(value,location.origin);
    if (url.origin !== location.origin) throw Error('Invalid storefront URL');
    const preview = new URL(location.href).searchParams.get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id',preview);
    return url;
  };
  const parse = html => {const document=new DOMParser().parseFromString(html,'text/html');document.querySelectorAll('noscript').forEach(node=>node.remove());return document;};
  const announce = (message, error = false) => {
    document.querySelectorAll('[data-cart-message]').forEach(node => {node.textContent = message; node.classList.toggle('is-error',error);});
    const toast = document.querySelector('[data-toast]');
    if (toast) {toast.textContent = message; toast.hidden = false; clearTimeout(announce.timer); announce.timer = setTimeout(() => {toast.hidden = true;},6000);}
  };
  const modalOpen = (dialog, opener = document.activeElement) => {
    if (!dialog) return;
    dialog.catwaOpener = opener;
    if (!dialog.open) dialog.showModal();
    document.documentElement.classList.add('catwa-modal-open');
  };
  const modalClose = dialog => {
    if (dialog?.open) dialog.close();
  };
  document.addEventListener('close', event => {
    const dialog = event.target;
    if (!(dialog instanceof HTMLDialogElement)) return;
    dialog.querySelectorAll('video').forEach(video => video.pause());
    dialog.querySelectorAll('iframe').forEach(frame => {const src=frame.src; frame.src=src;});
    if (!document.querySelector('dialog[open]')) document.documentElement.classList.remove('catwa-modal-open');
    if (dialog.catwaOpener?.isConnected && !dialog.catwaOpener.closest('dialog:not([open])')) dialog.catwaOpener.focus({preventScroll:true});
  }, true);
  let queue = Promise.resolve(), pending = 0, quickSequence = 0, quickRequest;
  const cartBusy = value => {
    document.querySelectorAll('[data-cart-form]').forEach(form => {
      form.toggleAttribute('aria-busy',value);
      form.querySelectorAll('button,input,textarea').forEach(control => {
        if (value) {if (!control.hasAttribute('data-cart-disabled')) control.dataset.cartDisabled = String(control.disabled); control.disabled=true;}
        else if (control.hasAttribute('data-cart-disabled')) {control.disabled=control.dataset.cartDisabled==='true'; delete control.dataset.cartDisabled;}
      });
      form.querySelector('catwa-cart-terms')?.sync();
    });
  };
  const renderCart = async payload => {
    let html = payload?.sections?.['catwa-cart-panel'];
    if (!html) {
      const url = safeURL(config.dataset.cartUrl); url.searchParams.set('section_id','catwa-cart-panel');
      const response = await fetch(url,{credentials:'same-origin',cache:'no-store',signal:AbortSignal.timeout(15000)});
      if (!response.ok) throw Error(config.dataset.error);
      html=await response.text();
    }
    const source = parse(html).querySelector('[data-cart-content]');
    if (!source) throw Error(config.dataset.error);
    const count = Number(source.dataset.cartCountValue);
    if (!Number.isInteger(count) || count < 0) throw Error(config.dataset.error);
    if (count === 0) customElements.get('catwa-cart-terms')?.setAccepted(false);
    document.querySelectorAll('[data-cart-drawer-body]').forEach(target => target.replaceChildren(source.cloneNode(true)));
    const page = document.querySelector('[data-cart-page-body]');
    if (page) {
      const copy = source.cloneNode(true);
      copy.querySelectorAll('[id]').forEach(node => {node.id=node.id.replace(/-drawer/g,'-page');});
      copy.querySelectorAll('[for]').forEach(node => node.htmlFor=node.htmlFor.replace(/-drawer/g,'-page'));
      copy.querySelectorAll('[aria-controls]').forEach(node => node.setAttribute('aria-controls',node.getAttribute('aria-controls').replace(/-drawer/g,'-page')));
      copy.querySelectorAll('[aria-describedby]').forEach(node => node.setAttribute('aria-describedby',node.getAttribute('aria-describedby').replace(/-drawer/g,'-page')));
      copy.querySelectorAll('catwa-discount').forEach(node => node.dataset.scope='page');
      const mainForm=copy.querySelector('[data-cart-form]');if(mainForm)mainForm.id='CatwaCart-page';
      page.replaceChildren(copy);
    }
    document.querySelectorAll('[data-cart-count]').forEach(node => {node.textContent=count;});
    cartBusy(pending>0);
    document.dispatchEvent(new CustomEvent('catwa:content-updated'));
    document.dispatchEvent(new CustomEvent('catwa:cart-updated',{detail:{itemCount:count}}));
  };
  const mutateCart = (path, body, options = {}) => {
    pending++; cartBusy(true);
    const task = queue.then(async () => {
      const headers = {'Accept':'application/json'};
      const sectionURL = safeURL(config.dataset.cartUrl);
      const sectionsUrl=sectionURL.pathname+sectionURL.search;
      if (body instanceof FormData) {body.set('sections','catwa-cart-panel'); body.set('sections_url',sectionsUrl);}
      else {body={...body,sections:['catwa-cart-panel'],sections_url:sectionsUrl}; headers['Content-Type']='application/json';}
      const response = await fetch(safeURL(root+'cart/'+path+'.js'),{method:'POST',headers,body:body instanceof FormData?body:JSON.stringify(body),credentials:'same-origin',signal:AbortSignal.timeout(20000)});
      const payload = await response.json();
      if (!response.ok || payload.status >= 400) throw Error(typeof payload.description==='string'?payload.description:config.dataset.error);
      await renderCart(payload);
      if (options.added) {
        modalClose(quick);
        document.querySelectorAll('.catwa-shoppable-dialog[open]').forEach(modalClose);
      }
      announce(options.added?config.dataset.added:config.dataset.updated);
      return options.returnPayload ? payload : true;
    }).catch(async error => {
      announce(error.message || config.dataset.error,true);
      try {await renderCart();} catch (_) {}
      return false;
    }).finally(() => {pending--; if (!pending) cartBusy(false);});
    queue=task;
    return task;
  };
  const openQuickView = async (url, opener) => {
    const sequence=++quickSequence;
    quickRequest?.abort(); quickRequest=new AbortController();
    const controller=quickRequest, timeout=setTimeout(()=>controller.abort(),15000);
    modalClose(drawer); modalOpen(quick,opener);
    const target=quick.querySelector('[data-quick-view-content]'); target.textContent=config.dataset.loading; target.setAttribute('aria-busy','true');
    try {
      const request=safeURL(url); request.searchParams.set('section_id','catwa-quick-view');
      const response=await fetch(request,{credentials:'same-origin',signal:controller.signal});
      if (!response.ok) throw Error('Quick view unavailable');
      const content=parse(await response.text()).querySelector('[data-quick-product]');
      if (!content) throw Error('Missing quick product');
      if (sequence!==quickSequence || !quick.open) return;
      target.replaceChildren(content);
      window.Shopify?.PaymentButton?.init?.();
      recordRecent(content.querySelector('[data-handle]')?.dataset.handle);
      document.dispatchEvent(new CustomEvent('catwa:content-updated'));
    } catch (error) {
      if (sequence!==quickSequence) return;
      const text=document.createElement('p'); text.textContent=config.dataset.quickError;
      const link=document.createElement('a'); link.className='button'; link.href=safeURL(url); link.textContent=opener?.textContent.trim() || config.dataset.quickError;
      target.replaceChildren(text,link);
    } finally {clearTimeout(timeout); if (sequence===quickSequence) target.removeAttribute('aria-busy');}
  };
  const runAdd = async (button, body, form) => {
    if (button?.dataset.adding==='true') return;
    if (button) {button.dataset.adding='true';button.disabled=true;}
    if (form) form.inert=true;
    const success=await mutateCart('add',body,{added:true,opener:button});
    if (form) form.inert=false;
    if (button) {delete button.dataset.adding; button.disabled=false;}
    const product=form?.closest('catwa-product');
    if (product) {product.syncSticky?.();const status=product.querySelector('[data-variant-status]');if(status)status.textContent=success?config.dataset.added:config.dataset.error;}
    return success;
  };
  document.addEventListener('submit', async event => {
    const form=event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (form.matches('.catwa-product-form')) {
      if (event.defaultPrevented) return;
      event.preventDefault();
      const button=form.querySelector('[data-add-to-cart]'), id=form.querySelector('[name="id"]');
      if (!id?.value || id.disabled || button.disabled || !form.reportValidity()) return;
      await runAdd(button,new FormData(form),form.closest('catwa-product') || form);
    } else if (form.matches('[data-cart-form]')) {
      if (event.defaultPrevented) return;
      if (event.submitter?.name === 'checkout' && pending > 0) {
        event.preventDefault(); const id=form.id; await queue;
        const current=document.getElementById(id);
        const checkout=current?.querySelector('button[name="checkout"]');
        if (checkout && !checkout.disabled) current.requestSubmit(checkout);
      }
    } else if (form.matches('.catwa-stock-form')) {
      const button=form.querySelector('[data-stock-submit]');
      if (!button?.dataset.endpoint) return;
      event.preventDefault();
      const status=form.querySelector('[data-stock-status]');
      try {
        const endpoint=safeURL(button.dataset.endpoint);
        if (!endpoint.pathname.startsWith('/apps/')) throw Error('Invalid notification endpoint');
        button.disabled=true;
        const response=await fetch(endpoint,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},credentials:'same-origin',body:JSON.stringify({email:new FormData(form).get('contact[email]'),variant_id:button.dataset.variant,locale:document.documentElement.lang}),signal:AbortSignal.timeout(15000)});
        const confirmation=await response.json();
        if (!response.ok || confirmation.success!==true) throw Error('Request failed');
        status.textContent=config.dataset.requestSent;form.reset();
      } catch (_) {status.textContent=config.dataset.requestError;}
      finally {button.disabled=false;}
    }
  });
  document.addEventListener('input',event=>{if(event.target.matches('[data-cart-quantity]'))event.target.setCustomValidity('');});
  document.addEventListener('change', event => {
    const target=event.target;
    if (target.matches('[data-cart-quantity]')) {
      let quantity=Number(target.value);
      const minimum=Number(target.dataset.minimum)||1, step=Number(target.dataset.increment)||1;
      if (!Number.isInteger(quantity) || quantity<0 || (quantity>0 && (quantity<minimum || (quantity-minimum)%step!==0)) || (target.max && quantity>Number(target.max))) {target.setCustomValidity(target.dataset.ruleMessage || config.dataset.error);target.reportValidity();return;}
      target.setCustomValidity('');
      mutateCart('change',{id:target.dataset.lineKey,quantity});
    } else if (target.matches('[data-cart-note]')) mutateCart('update',{note:target.value});
    else if (target.matches('[data-gift-message]')) mutateCart('update',{attributes:{'Gift message':target.value}});
  });
  document.addEventListener('click', async event => {
    const target=event.target;
    if (!(target instanceof Element)) return;
    const close=target.closest('[data-dialog-close]'); if (close) {event.preventDefault();modalClose(close.closest('dialog'));return;}
    if (target instanceof HTMLDialogElement && target.id!=='CatwaAgeGate') {const rect=target.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)modalClose(target);}
    const cartLink=target.closest('a[href]');
    if (cartLink && config.dataset.cartDrawer==='true' && !cartLink.closest('[data-cart-form], .catwa-cart-fallback') && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey) {
      const linkURL=new URL(cartLink.href), cartURL=new URL(config.dataset.cartUrl,location.origin);
      if (linkURL.origin===location.origin && linkURL.pathname===cartURL.pathname && !cartLink.closest('#CatwaCartDrawer')) {event.preventDefault();modalOpen(drawer,cartLink);try {await queue;await renderCart();}catch(_){announce(config.dataset.error,true);}return;}
    }
    const quickLink=target.closest('[data-quick-view]');
    if (quickLink && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey) {event.preventDefault();openQuickView(quickLink.dataset.quickView,quickLink);return;}
    const add=target.closest('[data-quick-add]');
    if (add && !add.disabled) {event.preventDefault();await runAdd(add,{items:[{id:add.dataset.quickAdd,quantity:Number(add.dataset.quantity)||1}]});return;}
    const remove=target.closest('[data-cart-remove]');
    if (remove) {event.preventDefault();if(!pending)await mutateCart('change',{id:remove.dataset.cartRemove,quantity:0});return;}
    const zoom=target.closest('[data-zoom-src]');
    if (zoom) {const img=media.querySelector('[data-zoom-image]');img.src=zoom.dataset.zoomSrc;img.alt=zoom.dataset.zoomAlt;media.classList.remove('is-zoomed');modalOpen(media,zoom);return;}
    const zoomToggle=target.closest('[data-zoom-toggle]');if(zoomToggle){const enabled=media.classList.toggle('is-zoomed');zoomToggle.setAttribute('aria-pressed',String(enabled));return;}
    const top=target.closest('[data-back-top]');if(top){window.scrollTo({top:0,behavior:reducedMotion()?'instant':'smooth'});document.querySelector('.skip-link')?.focus({preventScroll:true});return;}
    const open=target.closest('[data-open-dialog]');if(open){event.preventDefault();modalOpen(document.getElementById(open.dataset.openDialog),open);return;}
    const bundle=target.closest('[data-add-bundle]');
    if(bundle){const area=bundle.closest('[data-bundle-area]');const items=[...area.querySelectorAll('[data-bundle-item]:checked')].filter(input=>!input.disabled&&!input.closest('[hidden]')).map(input=>({id:input.value,quantity:Number(input.dataset.quantity)||1}));if(items.length)await runAdd(bundle,{items},area);syncBundles();return;}
    const clearRecent=target.closest('[data-clear-recent]');if(clearRecent){recentMemory=[];try{localStorage.removeItem('catwa-recent');}catch(_){}document.dispatchEvent(new CustomEvent('catwa:recent-change'));return;}
  });
  const syncBundles=()=>document.querySelectorAll('[data-bundle-area]').forEach(area=>{const button=area.querySelector('[data-add-bundle]');if(button&&!button.dataset.adding)button.disabled=![...area.querySelectorAll('[data-bundle-item]:checked')].some(input=>!input.disabled&&!input.closest('[hidden]'));});
  document.addEventListener('change',event=>{if(event.target.matches('[data-bundle-item]'))syncBundles();});
  document.addEventListener('catwa:content-updated',syncBundles);
  const age=document.getElementById('CatwaAgeGate');
  if(age && config.dataset.editor!=='true') {
    const key='catwa-age-'+age.dataset.age;let accepted=false;try{accepted=sessionStorage.getItem(key)==='yes';}catch(_){}
    if(!accepted)modalOpen(age);
    age.addEventListener('cancel',event=>event.preventDefault());
    age.querySelector('[data-age-confirm]').addEventListener('click',()=>{try{sessionStorage.setItem(key,'yes');}catch(_){}modalClose(age);});
    age.querySelector('[data-age-deny]').addEventListener('click',()=>{age.querySelector('[data-age-denied]').hidden=false;});
  }
  const backTop=document.querySelector('[data-back-top]');
  if(backTop){let scheduled=false;const update=()=>{scheduled=false;backTop.hidden=scrollY<600;if(!backTop.hidden){const a=backTop.getBoundingClientRect();const collision=[...document.querySelectorAll('[data-story-controls] button,.catwa-hotspot-pin,[data-quiz-next]')].some(el=>{const b=el.getBoundingClientRect();return b.width>0&&b.height>0&&a.left<b.right+8&&a.right>b.left-8&&a.top<b.bottom+8&&a.bottom>b.top-8;});if(collision)backTop.hidden=true;}};window.addEventListener('scroll',()=>{if(!scheduled){scheduled=true;requestAnimationFrame(update);}},{passive:true});update();}
  document.addEventListener('keydown',event=>{if(event.key==='Escape')document.querySelectorAll('.catwa-account[open]').forEach(account=>{account.open=false;account.querySelector('summary').focus();});});
  document.addEventListener('click',event=>document.querySelectorAll('.catwa-account[open]').forEach(account=>{if(!account.contains(event.target))account.open=false;}));
  let recentMemory=[];
  const validHandle=value=>typeof value==='string'&&value.length<=255&&/^[\p{L}\p{N}_-]+$/u.test(value);
  const readRecent=()=>{try{const data=JSON.parse(localStorage.getItem('catwa-recent')||'[]');if(Array.isArray(data))recentMemory=[...new Set(data.filter(validHandle))].slice(0,24);}catch(_){}return recentMemory;};
  function recordRecent(handle){if(!validHandle(handle))return;recentMemory=[handle,...readRecent().filter(value=>value!==handle)].slice(0,24);try{localStorage.setItem('catwa-recent',JSON.stringify(recentMemory));}catch(_){}document.dispatchEvent(new CustomEvent('catwa:recent-change'));}
  if(!customElements.get('catwa-recent'))customElements.define('catwa-recent',class extends HTMLElement{
    connectedCallback(){this.events=new AbortController();this.generation=0;document.addEventListener('catwa:recent-change',()=>this.render(),{signal:this.events.signal});if(!readRecent().some(handle=>handle!==this.dataset.exclude)){this.activated=true;this.render();return;}if('IntersectionObserver'in window){this.observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){this.observer.disconnect();this.activated=true;this.render();}},{rootMargin:'200px'});this.observer.observe(this);}else{this.activated=true;this.render();}}
    async render(){if(!this.activated)return;const generation=++this.generation;this.request?.abort();this.request=new AbortController();const handles=readRecent().filter(handle=>handle!==this.dataset.exclude).slice(0,Number(this.dataset.limit)||6);const grid=this.querySelector('[data-recent-grid]');if(!handles.length){grid.replaceChildren();this.hidden=config.dataset.editor!=='true';return;}this.hidden=false;this.setAttribute('aria-busy','true');const cards=await Promise.all(handles.map(async handle=>{try{const url=safeURL(root+'products/'+encodeURIComponent(handle));url.searchParams.set('section_id','catwa-product-card');const response=await fetch(url,{signal:this.request.signal,credentials:'same-origin'});if(!response.ok)return null;return parse(await response.text()).querySelector('.product-card');}catch(_){return null;}}));if(generation!==this.generation||!this.isConnected)return;grid.replaceChildren(...cards.filter(Boolean));this.hidden=!cards.some(Boolean)&&config.dataset.editor!=='true';this.removeAttribute('aria-busy');document.dispatchEvent(new CustomEvent('catwa:content-updated'));}
    disconnectedCallback(){this.events?.abort();this.request?.abort();this.observer?.disconnect();}
  });
  if(!customElements.get('catwa-before-after'))customElements.define('catwa-before-after',class extends HTMLElement{
    connectedCallback(){this.events=new AbortController();const slider=this.querySelector('input[type="range"]');const update=()=>{this.style.setProperty('--reveal',slider.value+'%');slider.setAttribute('aria-valuetext',slider.value+'%');};slider.addEventListener('input',update,{signal:this.events.signal});update();}disconnectedCallback(){this.events?.abort();}
  });
  if(!customElements.get('catwa-quiz'))customElements.define('catwa-quiz',class extends HTMLElement{
    connectedCallback(){this.events=new AbortController();this.step=0;this.fields=[...this.querySelectorAll('[data-quiz-step]')];this.fields.forEach((field,index)=>{const select=field.querySelector('select'),grid=field.querySelector('[data-quiz-answers]');select.querySelectorAll('option:not(:first-child)').forEach(o=>o.remove());const values=[...new Set([...this.querySelectorAll('[data-quiz-result]')].map(item=>item.dataset['answer'+(index+1)]).filter(Boolean))];values.forEach(value=>select.add(new Option(value,value)));if(this.dataset.style==='cards'&&grid){grid.replaceChildren();[...select.options].forEach((option,i)=>{const label=document.createElement('label'),input=document.createElement('input'),text=document.createElement('span');input.type='radio';input.name='quiz-'+this.dataset.id+'-'+index;input.value=option.value;input.checked=i===0;text.textContent=option.textContent;label.append(input,text);grid.append(label);input.addEventListener('change',()=>select.value=input.value,{signal:this.events.signal});});select.hidden=true;grid.hidden=false;}});this.addEventListener('click',event=>{if(event.target.closest('[data-quiz-start]')){this.querySelector('[data-quiz-intro]').hidden=true;this.querySelector('[data-quiz-results]').hidden=true;this.querySelector('[data-quiz-questions]').hidden=false;this.update();}if(event.target.closest('[data-quiz-close]')){this.querySelector('[data-quiz-questions]').hidden=true;this.querySelector('[data-quiz-results]').hidden=true;this.querySelector('[data-quiz-intro]').hidden=false;this.querySelector('[data-quiz-start]').focus();}if(event.target.closest('[data-quiz-next]')){if(this.step<this.fields.length-1){this.step++;this.update();}else this.results();}if(event.target.closest('[data-quiz-back]')){this.step=Math.max(0,this.step-1);this.update();}if(event.target.closest('[data-quiz-reset]')){this.querySelectorAll('select').forEach(select=>select.value='');this.querySelectorAll('input[type="radio"]').forEach(input=>input.checked=input.value==='');this.step=0;this.querySelector('[data-quiz-results]').hidden=true;this.querySelector('[data-quiz-questions]').hidden=false;this.update();}},{signal:this.events.signal});this.update(false);}
    update(focus=true){this.fields.forEach((field,index)=>field.hidden=index!==this.step);this.querySelector('[data-quiz-progress]').textContent=(this.step+1)+' / '+this.fields.length;const meter=this.querySelector('[data-quiz-meter]');if(meter)meter.value=this.step+1;this.querySelector('[data-quiz-back]').hidden=this.step===0;const next=this.querySelector('[data-quiz-next]');next.textContent=this.step===this.fields.length-1?next.dataset.results:next.dataset.next;if(focus)(this.fields[this.step].querySelector('input:checked')||this.fields[this.step].querySelector('select')).focus();}
    results(){const answers=this.fields.map(field=>field.querySelector('select').value),requested=answers.filter(Boolean).length;const results=[...this.querySelectorAll('[data-quiz-result]')].map((item,index)=>({item,index,score:answers.reduce((score,answer,i)=>score+(answer&&item.dataset['answer'+(i+1)]===answer?1:0),0)})).sort((a,b)=>b.score-a.score||a.index-b.index);const seen=new Set();const relevant=results.filter(result=>{const handle=result.item.dataset.product;if(seen.has(handle)||requested&&result.score===0)return false;seen.add(handle);return true;});const exact=relevant.filter(result=>result.score===requested);const selected=(exact.length?exact:relevant).slice(0,Number(this.dataset.limit)||3);results.forEach(result=>{result.item.hidden=true;result.item.querySelectorAll('[data-bundle-item]').forEach(input=>input.checked=false);});const grid=this.querySelector('[data-quiz-grid]');selected.forEach(result=>{result.item.hidden=false;result.item.querySelectorAll('[data-bundle-item]').forEach(input=>input.checked=true);grid.append(result.item);});this.querySelector('[data-quiz-questions]').hidden=true;const panel=this.querySelector('[data-quiz-results]');panel.hidden=false;panel.querySelector('[data-quiz-result-title]').focus();const bundle=panel.querySelector('[data-add-bundle]');if(bundle)bundle.hidden=!selected.some(result=>result.item.querySelector('[data-bundle-item]'));this.querySelector('[data-quiz-status]').textContent=!selected.length?this.dataset.empty:requested&&!exact.length?this.dataset.near:'';const browse=this.querySelector('[data-quiz-browse]');if(browse)browse.hidden=selected.length>0;syncBundles();}
    disconnectedCallback(){this.events?.abort();}
  });
  document.querySelectorAll('catwa-product[data-history="true"]').forEach(product=>recordRecent(product.dataset.handle));
  syncBundles();
  window.CatwaCommerce={refresh:renderCart,update:body=>mutateCart('update',body,{returnPayload:true}),addItems:items=>mutateCart('add',{items},{added:true}),openQuickView};
})();
